<template>
  <v-row class="text-center">
    <v-col cols="12" md="6" class="mx-auto">
      <v-img :src="company_logo" max-width="320" class="mx-auto mb-md-4 company-logo" />
      <v-row id="homecards">
        <v-col cols="6" md="4" class="my-8">
          <router-link
            :to="{ name: 'account' }"
            id="add-member"
            class="text-uppercase"
            tag="button"
          >
            <v-img
              src="/assets/images/addpatient.jpg"
              aspect-ratio="1"
              max-width="80"
              class="mb-4 mx-auto"
            />Add Member
          </router-link>
        </v-col>

        <v-col cols="6" md="4" class="my-8">
          <div>
            <router-link :to="{ name: 'member' }" class="text-uppercase">
              <v-img
                src="/assets/images/memberlookup.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              />Member Lookup
            </router-link>
          </div>
        </v-col>

        <v-col cols="6" md="4" class="my-8">
          <div>
            <router-link
              :to="{ name: 'visit-member-lookup' }"
              class="text-uppercase"
            >
              <v-img
                src="/assets/images/logvisit.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              />Log Benefits
            </router-link>
          </div>
        </v-col>

        <v-col cols="6" md="4" class="my-8">
          <div>
            <router-link
              :to="{ name: 'payouts' }"
              class="text-uppercase"
              v-if="$enableClaims"
            >
              <v-img
                src="/assets/images/rewards.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              />CLAIMS
            </router-link>
            <router-link :to="{ name: 'reward' }" class="text-uppercase" v-else-if="!$enableClaims && company.supress_rewards === 0">
              <v-img
                src="/assets/images/rewards.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              />Redeem Rewards
            </router-link>
          </div>
        </v-col>

        <v-col cols="6" md="4" class="my-8">
          <div>
            <router-link
              :to="{ name: 'payment', params: { id: $auth.company_id } }"
              class="text-uppercase payments-home"
            >
              <div class="counter" v-if="pastDueInvoices.length">
                {{ ("0" + pastDueInvoices.length).slice(-2) }}
              </div>
              <v-img
                src="/assets/images/payments.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              />Payments
            </router-link>
          </div>
        </v-col>

        <v-col cols="6" md="4" class="my-8">
          <div>
            <router-link
              :to="{ name: 'schedule' }"
              class="text-uppercase schedule-home"
            >
              <v-img
                src="/assets/images/schedule.jpg"
                aspect-ratio="1"
                max-width="80"
                class="mb-4 mx-auto"
              >
                <div class="counter-left" v-if="newMembersCount > 0">
                  {{ newMembersCount }}
                </div>
                <div class="counter-right" v-if="recareEligibleMembers > 0">
                  {{ recareEligibleMembers }}
                </div> </v-img
              >Schedule
            </router-link>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import toast from "../services/toast";
import MemberRest from "../rest/MemberRest";
import ScheduleRest from "../rest/ScheduleRest";
import CompanyRest from "../rest/CompanyRest";
import ImpersonateAlert from "./shared/AppImpersonateUserAlert";
import CompanyInvoiceRest from "../rest/CompanyInvoiceRest";
import _ from "lodash";

export default {
  components: {
    "impersonate-alert": ImpersonateAlert,
  },
  data: function () {
    return {
      company: null,
      company_logo: "",
      pastDueInvoices: [],
      recareEligibles: [],
      scheduledMembers: [],
      members: {},
      schedMembers: {},
      newMembersCount: null,
      recareEligibleMembers: null,
    };
  },
  created() {
    console.log(this.$auth.company_id);
    this.getMembers();
    this.getMembersForRecare();
    this.getFailedInvoices(this.$auth.company_id);
    this.getRecareEligibles();
    this.getScheduledMembers();
    this.loadCompany();
    this.getScheduleCounters();

    if (this.$route.query.connect) {
      if (this.$route.query.connect == "success") {
        toast.success(
          "Stripe account has been successfully connected to Dental Menu",
          "",
          [toast.generateDismissBtn()]
        );
      } else if (this.$route.query.connect === "error") {
        toast.success(
          "There was an error connecting this Stripe account to Dental Menu. Please try again later",
          "",
          [toast.generateDismissBtn()]
        );
      }
    }
  },

  computed: {
    newMembers() {
      const newMemberList = [];
      _.forIn(this.schedMembers, function (value, key) {
        var totalTransactions = _(value.transactions)
          .groupBy("invoice_id")
          .map((t, key) => ({
            total_amount: _.sumBy(t, "amount"),
            invoice_id: key,
          }))
          .value();
        value.transactionDetails =
          totalTransactions.length !== 0 ? totalTransactions[0] : 0;
        if (_.isEmpty(value.benefit_member) && _.isEmpty(value.schedule)) {
          newMemberList.push(value);
        } else {
          const dateNow = new Date();
          if (!_.isEmpty(value.schedule)) {
            const selectedDate = new Date(value.schedule.selected_date);
            if (dateNow > selectedDate && _.isEmpty(value.benefit_member)) {
              // remove schedule if no benefit has been redeemed
              ScheduleRest.DestroySchedule(value.schedule.id);
              newMemberList.push(value);
            }
          }
        }
      });
      return newMemberList;
    },
    eligibleMembers() {
      if (this.recareEligibles.length > 0) {
        const membersWithRecare = _.map(this.recareEligibles, "member");
        return _.filter(this.members, (member) => {
          return _.find(membersWithRecare, { id: member.id });
        });
      }

      return [];
    },
  },

  methods: {
    getFailedInvoices(companyId) {
      //this.loading = true
      CompanyInvoiceRest.failedInvoices(companyId)
        .then((response) => {
          //console.log(response.data)
          //this.pastDueInvoices = _.filter(response.data, function (i) {
          //const start = moment(i.period_start)
          //const end = moment(i.period_end)
          //const now = moment()
          //return now.diff(start, 'days') <= 30 && !i.member.deactivated_at
          //console.log(now.diff(end, 'days'))
          //return !i.member.deactivated_at
          //return i
          //})

          this.pastDueInvoices = response.data.filter((i) => {
            return !i.member.deactivated_at;
          });
          //this.loading = false
          console.log(this.pastDueInvoices);
        })
        .catch((error) => {
          //console.dir(error)
          //this.loading = false
        });
    },
    async getRecareEligibles() {
      const { data } = await ScheduleRest.FetchRecareEligibles();
      console.log(data);
      this.recareEligibles = data;
    },
    async getScheduledMembers() {
      const queryString = "getSchedule=true&getBenefitMember=true&getPlan=true";
      const { data } = await MemberRest.FetchMembersCustom(queryString);
      this.scheduledMembers = data;
    },
    async loadCompany() {
      const { data } = await CompanyRest.FetchCompany(this.$auth.company_id);
      if (data) {
        this.company = data;
        this.company_logo =
          data.logo_url !== null
            ? "/media/logos/" + data.logo_url
            : "/assets/images/directdentalcare.jpg";
      }
    },
    async getMembers() {
      const queryString =
        "getSchedule=true&getBenefitMember=true&getInvoiceItems=true&getAccount=true&includeInactive=false&getPlan=true&noHistory=true";
      let { data } = await MemberRest.FetchMembersCustom(queryString);
      if (Array.isArray(data)) {
        this.schedMembers = data.filter((m) => {
          if (m.plan) {
            return m;
          }
        });
      }
    },

    async getMembersForRecare() {
      const queryString = "getSchedule=true&getBenefitMember=true&getPlan=true";
      const { data } = await MemberRest.FetchMembersCustom(queryString);
      this.members = data;
    },

    async getScheduleCounters() {
      const response = await ScheduleRest.FetchCounters();
      this.newMembersCount = response.data.new_members;
      this.recareEligibleMembers = response.data.recare_eligibles;
    },
  },
};
</script>

<style lang="scss">
.company-logo {
  margin-top: 8px;
}

.schedule-home {
  .v-responsive__content {
    position: relative;

    .counter-left {
      top: 0;
      left: 0;
      right: unset;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      border-radius: 50%;
    }

    .counter-right {
      top: 0;
      right: 0;
      left: unset;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      border-radius: 50%;
    }
  }
}
</style>
